import baseAPI from "@/api/base";
import {
  CreateBucketLockOverride,
  GetBucketLockSettings,
  GetBucketLockStatus,
  GetBucketLockOverrides,
  UpdateBucketLockSettings,
} from "@/dtos/BucketLock.dto";
import {
  CREATE_BUCKET_LOCK_OVERRIDE_URL,
  DELETE_BUCKET_LOCK_OVERRIDE_URL,
  GET_BUCKET_LOCK_SETTINGS_URL,
  GET_BUCKET_LOCK_STATUS_URL,
  GET_BUCKET_LOCK_OVERRIDES_URL,
  UPDATE_BUCKET_LOCK_SETTINGS_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class BucketLock {
  static getBucketLockStatus = async (params: GetBucketLockStatus): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_BUCKET_LOCK_STATUS_URL, {
      params,
    });
    return response;
  };

  static getBucketLockSettings = async (params: GetBucketLockSettings): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_BUCKET_LOCK_SETTINGS_URL, {
      params,
    });
    return response;
  };

  static updateBucketLockSettings = async (
    data: UpdateBucketLockSettings
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(UPDATE_BUCKET_LOCK_SETTINGS_URL, {
      ...data,
    });
    return response;
  };

  static getBucketLockOverrides = async (
    params: GetBucketLockOverrides
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_BUCKET_LOCK_OVERRIDES_URL, {
      params,
    });
    return response;
  };

  static createBucketLockOverride = async (
    data: CreateBucketLockOverride
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(CREATE_BUCKET_LOCK_OVERRIDE_URL, {
      ...data,
    });
    return response;
  };

  static deleteBucketLockOverride = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_BUCKET_LOCK_OVERRIDE_URL}/${id}`
    );
    return response;
  };
}

export default BucketLock;
